/**
 * Random comments used through out the project.
 */

export const DISCARD_TITLE = 'Discard Changes?';
export const DISCARD_CONTENT = 'You have unsaved changed. Are you sure you want to leave this page?';

export const WAIT_IMAGES_TO_LOAD = 'Please wait for the images to load before opening each image';

export const PLAYER_DELETED = 'Player not found';
export const ALUMNI_DELETED = 'Alumni not found';
export const COACH_DELETED = 'Coach not found';

export const ARTICLE_DELETED = 'This article is not available anymore';
export const ARTICLE_NOT_PUBLISHED = 'This article is not available at the moment';

export const GALLERY_DELETED = 'This gallery is not available anymore';
export const GALLERY_NOT_PUBLISHED = 'This gallery is not available at the moment';

export const EVENT_DELETED = 'This event is not available anymore';
export const EVENT_NOT_PUBLISHED = 'This event is not available at the moment';

export const CUSTOMPAGE_DELETED = 'This web page is not available anymore';
export const CUSTOMPAGE_NOT_PUBLISHED = 'This web page is not available at the moment';

export const FORM_DELETED = 'This form is not available anymore';
export const FORM_NOT_PUBLISHED = 'This form is not available at the moment';

export const PRODUCT_DELETED = 'This product is not available anymore';
export const PRODUCT_NOT_PUBLISHED = 'This product is not available at the moment';
export const PRODUCT_OUT_OF_STOCK = 'This product is out of stock';

export const TEST_WEBSITE_NOT_FOUND = 'Please access this website again using your portal';
